export const validationMessages = {
  username: "Username is required.",
  email: "Email address is required.",
  password: "Password is required.",
  confirmPassword: "Confirm password is requied.",
  passwordCheck: "Password did not match!",
};
